interface Firmware { deviceTypeId?: unknown; version?: unknown }

function safeFilename(value: string): string {
    return Array.from(value).map(char => char === '/' || char === '\\' || char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127 ? '_' : char).join('').replace(/^\.+/, '').trim();
}

export function firmwareFilename(header: unknown, firmware: Firmware): string {
    if (typeof header === 'string') {
        const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
        if (encoded) {
            try { const name = safeFilename(decodeURIComponent(encoded[1].trim())); if (name) return name; } catch { /* Try the plain filename. */ }
        }
        const plain = /(?:^|;)\s*filename\s*=\s*(?:"([^"]*)"|([^;]*))/i.exec(header);
        if (plain) { const name = safeFilename((plain[1] ?? plain[2]).trim()); if (name) return name; }
    }
    return safeFilename(String(firmware.deviceTypeId ?? 'firmware') + '-' + String(firmware.version ?? 'download') + '.dfw');
}

export function saveDownload(data: BlobPart, filename: string): void {
    const url = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }));
    const link = document.createElement('a');
    try {
        link.href = url; link.download = filename;
        document.body.appendChild(link); link.click();
    } finally {
        link.remove();
        // Let the browser start the download before revoking its temporary URL.
        setTimeout(() => window.URL.revokeObjectURL(url), 0);
    }
}
